import { shallowEqual, useSelector } from 'react-redux'

import Price from '@components/UI/Price/Price'
import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectPriceForDisplay, selectSubmission } from '@store/submissions'
import Theme from '@theme'
import { H5 } from '@tribegroup'
import { PriceWrapper } from '../Header.styled'

interface ISubmissionCardHeaderPriceProps {
  submissionId: number
  campaignId: number
  enableCostBreakdownTracking?: boolean
  toggleCostBreakdown?: (event: React.MouseEvent) => void
}

export const SubmissionCardHeaderPrice: React.FC<ISubmissionCardHeaderPriceProps> = ({
  toggleCostBreakdown,
  campaignId,
  submissionId,
  enableCostBreakdownTracking,
}) => {
  const { currency, price, priceChanged } = useSelector((state: IApplicationState) => {
    const { price, currency } = selectPriceForDisplay(state, submissionId, campaignId)
    const { first_preapproved_cents } = selectSubmission(state, submissionId)

    return {
      price,
      currency,
      priceChanged: Boolean(first_preapproved_cents),
    }
  }, shallowEqual)

  return (
    <H5
      className="price"
      color={Theme.grey900Color}
      data-cy-element="price"
      leftOuterSpacing={0.75}
    >
      <ConnectedTrackedRoute
        disableTracking={enableCostBreakdownTracking}
        eventName={EventTrackingNames.ViewPriceSummary}
        campaignId={campaignId}
        submissionId={submissionId}
      >
        <PriceWrapper onClick={toggleCostBreakdown} role="button">
          <Price
            quantity={price || 0}
            currency={currency || ''}
            rounded
            pattern={priceChanged ? '!###,###*' : undefined}
          />
        </PriceWrapper>
      </ConnectedTrackedRoute>
    </H5>
  )
}

export default SubmissionCardHeaderPrice
